import React from 'react'
import { Spin } from 'antd'

const LoadingSpinner: React.FC = () => (
  <div className="loading-wrapper">
    <Spin size="large" />
  </div>
)

export default LoadingSpinner
